import getRoomTypeWClient from "../queries/roomType/getRoomTypeWClient";

export default async (clientObj, jwt, success, fail) => {
  await getRoomTypeWClient(clientObj, jwt)
    .then((response) => {
      success(response);
    })
    .catch((err) => {
      fail(err);
    });
};
